<div class="mat-h3">Rollen &amp; Berechtigungen</div>
<p>
  Welche Funktionen ein Nutzer verwenden darf, ergibt sich aus den ihm zugewiesenen Rollen.
</p>
<ul>
  <li>
    <div class="mat-h4">Administrator</div>
    <p>Voller Zugriff auf alle Funktionen und Einstellungen. Verwaltet Nutzer, Rollen und Stammdaten.</p>
  </li>
  <li>
    <div class="mat-h4">Faktura</div>
    <p>Kompletter Abrechnungsprozess – Transportabrechnung (Trapo) und Rechnungsprüfung (Revisor).</p>
  </li>
  <li>
    <div class="mat-h4">Revisor</div>
    <p>Prüft und gibt Rechnungen frei (Rechnungs- und Absetzungsprüfung).</p>
  </li>
  <li>
    <div class="mat-h4">Trapo</div>
    <p>Erfasst und rechnet Transport- bzw. Fahrtdaten ab.</p>
  </li>
  <li>
    <div class="mat-h4">ServiceUser</div>
    <p>Service- und Supportzugang mit denselben Rechten wie Faktura (Trapo und Revisor).</p>
  </li>
</ul>
